import React from 'react';
import { Tooltip } from '@mui/material';
import './Tooltip.scss';
function ToolTip(props) {
	return (
		<div className="tooltip">
			<Tooltip
				title={props.title}
				placement={props.placement}
				arrow={props.arrow === false ? false : true}
			>
				<label>{props.content}</label>
			</Tooltip>
		</div>
	);
}

export default ToolTip;
